export enum ConsentStatus {
  NOT_ANSWERED = 'not_answered',
  OPT_IN_SINGLE = 'opt_in_single',
  OPT_IN_DOUBLE = 'opt_in_double',
  OPT_OUT = 'opt_out',
}
